import axios from "../config/axios"

const API_BASE = "/payment-history"

export const paymentService = {
  // Add payment to shipment
  addPayment: (shipmentId, data) => {
    if (data instanceof FormData) {
      return axios.post(`${API_BASE}/${shipmentId}/payment`, data, {
        headers: { 'Content-Type': undefined }
      })
    }
    return axios.post(`${API_BASE}/${shipmentId}/payment`, data)
  },

  addLateCharge: (shipmentId, amount, paymentMode) => {
    return axios.post(`/shipments/${shipmentId}/late-charge`, {
      late_charge: amount,
      payment_mode: paymentMode,
    })
  },

  // Get payment history for specific shipment
  getPaymentHistory: (shipmentId) => {
    return axios.get(`${API_BASE}/${shipmentId}/payment-history`)
  },

  // Send payment reminder
  sendPaymentReminder: (shipmentId) => {
    return axios.post(`${API_BASE}/${shipmentId}/send-payment-reminder`)
  },

  // Get pending payments with filters
  getPendingPayments: (params = {}) => {
    const queryParams = {
      page: params.page || 1,
      per_page: params.per_page || 20,
      ...(params.from_date && { from_date: params.from_date }),
      ...(params.to_date && { to_date: params.to_date }),
      ...(params.user_id && { user_id: params.user_id }),
    }
    return axios.get(`${API_BASE}/pending`, { params: queryParams })
  },

  // Get all payment history with filters
  getAllPaymentHistory: (params = {}) => {
    const queryParams = {
      page: params.page || 1,
      per_page: params.per_page || 20,
      ...(params.shipment_id && { shipment_id: params.shipment_id }),
      ...(params.from_date && { from_date: params.from_date }),
      ...(params.to_date && { to_date: params.to_date }),
      ...(params.payment_mode && { payment_mode: params.payment_mode }),
      ...(params.user_id && { user_id: params.user_id }),
      ...(params.all && { all: params.all }),
    }
    return axios.get(`${API_BASE}/history`, { params: queryParams })
  },

  // Get payment statistics
  getStatistics: () => {
    return axios.get(`${API_BASE}/statistics`)
  },

  // Delete payment history record
  deletePayment: (paymentId) => {
    return axios.delete(`${API_BASE}/${paymentId}`)
  },

  // Get single payment by ID
  getPaymentById: (paymentId) => {
    return axios.get(`${API_BASE}/payment/${paymentId}`)
  },

  // Update payment
  updatePayment: (paymentId, data) => {
    return axios.put(`${API_BASE}/payment/${paymentId}`, data)
  },

  // Get distinct users for filter dropdown
  getDistinctUsers: () => {
    return axios.get(`${API_BASE}/get_distinct_users`)
  },

  // Export payment history to CSV
  exportPaymentHistoryCSV: (queryString = "") => {
    return axios.get(`${API_BASE}/export/csv?${queryString}`, {
      responseType: "blob",
    })
  },

  // Export daily earnings to Excel
  exportDailyEarningsExcel: (queryString = "") => {
    return axios.get(`${API_BASE}/daily-earnings-excel?${queryString}`, {
      responseType: "blob",
    })
  },

  // Get shipment payment details (for modal)
  getShipmentPaymentDetails: (shipmentId) => {
    return axios.get(`${API_BASE}/shipment/${shipmentId}/details`)
  },
}

export default paymentService;